module.exports = __webpack_public_path__ + "static/media/logix_property.befd6737.png";